import { URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const productApi = apiSlice.injectEndpoints({
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (params) => ({
        url: `${URL}/products`,
        method: "GET",
        params: {
          page: params?.page,
          keyword: params?.keyword,
          category: params?.category,
          sup_category: params?.sup_category,
          select: params?.select,
          fields: params?.fields,
          sort: params?.sort,
          product_Attributes: params?.product_Attributes,
        },
      }),
      providesTags: ["Product"],
    }),

    getProductDetails: builder.query({
      query: (id) => `${URL}/products/${id}`,
    }),

    getCompareProducts: builder.query({
      /**
       * 根据商品 ID 列表批量拉取商品详情，用于前台零件对比页。
       * @param {string[]} ids 商品 ID 列表
       * @param {import("@reduxjs/toolkit/query").BaseQueryApi} _api RTK Query API
       * @param {unknown} _extraOptions 额外配置
       * @param {(arg: string) => Promise<any>} fetchWithBQ 基础请求函数
       * @returns {Promise<{data?: Record<string, any>, error?: any}>} 批量商品结果
       */
      async queryFn(ids = [], _api, _extraOptions, fetchWithBQ) {
        const productIds = Array.from(new Set(ids.filter(Boolean)));

        if (!productIds.length) {
          return { data: { products: [] } };
        }

        const responses = await Promise.all(
          productIds.map((id) => fetchWithBQ(`${URL}/products/${id}`))
        );
        const failedResponse = responses.find((response) => response.error);

        if (failedResponse) {
          return { error: failedResponse.error };
        }

        return {
          data: {
            products: responses
              .map((response) => response.data?.product)
              .filter(Boolean),
          },
        };
      },
    }),


    getAttributesValues: builder.query({
      query: (name) => ({
        url: `${URL}/products/attributes/values`,
        method: "GET",
        params: {
          categoryName: name,
        },
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductDetailsQuery,
  useGetCompareProductsQuery,
  useGetAttributesValuesQuery,
} = productApi;
